export default __webpack_public_path__ + "eddfbb01b16d67ffbb94a1cfed01c5b8.svg";